import type { FC, ReactNode } from 'react'

import Image from 'next/image'
import { ArrowLeft } from 'lucide-react'
import { ButtonLink } from '@/components/generals/button-link'
import { Tilt } from '@/components/generals/tilt'
import { SectionHeading } from '@/components/generals/section-heading'
import { LAB_TESTS } from '@/constants/content'
import { MEDIA } from '@/constants/media'

export const QualitySection: FC = (): ReactNode => {
    return (
        <section id='quality' aria-labelledby='quality-title' className='relative overflow-hidden bg-forest-950 py-24 text-cream lg:py-32'>
            <div aria-hidden='true' className='bg-girih pointer-events-none absolute inset-0 opacity-[0.05]' />
            <div aria-hidden='true' className='pointer-events-none absolute -bottom-40 -start-40 size-[34rem] rounded-full bg-gold/10 blur-3xl' />

            <div className='relative mx-auto grid max-w-7xl gap-16 px-5 sm:px-8 lg:grid-cols-12 lg:items-center lg:gap-12'>
                <div className='lg:col-span-7'>
                    <SectionHeading
                        id='quality-title'
                        tone='dark'
                        eyebrow='آزمایشگاه و کنترل کیفیت'
                        title='هر محموله، پیش از بسته‌بندی آنالیز می‌شود'
                        description='از هر محموله نمونه‌برداری می‌شود و نمونه‌ها در آزمایشگاه از نظر اصالت، پاکی و ایمنی بررسی می‌شوند. نتیجه این آزمون‌ها در برگه آنالیز همراه محموله به دست خریدار می‌رسد.'
                    />

                    <ul className='mt-10 grid gap-x-8 gap-y-6 sm:grid-cols-2'>
                        {LAB_TESTS.map(({ icon: Icon, title, text }) => (
                            <li key={title} className='flex items-start gap-4'>
                                <span className='flex size-11 shrink-0 items-center justify-center rounded-xl border border-gold/30 bg-gold/10 text-gold'>
                                    <Icon aria-hidden='true' className='size-5' strokeWidth={1.6} />
                                </span>

                                <span className='flex flex-col'>
                                    <span className='font-heading text-lg font-bold'>
                                        {title}
                                    </span>

                                    <span className='mt-0.5 text-sm leading-6 text-cream/65'>
                                        {text}
                                    </span>
                                </span>
                            </li>
                        ))}
                    </ul>

                    <ButtonLink href='/process#lab' variant='gold' className='mt-12'>
                        استاندارد کیفیت ما
                        <ArrowLeft aria-hidden='true' />
                    </ButtonLink>
                </div>

                <div className='lg:col-span-5'>
                    <div className='relative mx-auto w-full max-w-md'>
                        <div aria-hidden='true' className='absolute -inset-4 rounded-t-full rounded-b-[2.75rem] border border-gold/20' />

                        <Tilt max={5} className='rounded-t-full rounded-b-[2rem]'>
                            <div className='relative aspect-[3/4] overflow-hidden rounded-t-full rounded-b-[2rem] border border-gold/40 shadow-[0_50px_100px_-40px_rgba(0,0,0,0.9)]'>
                                <Image
                                    src={MEDIA.laboratory}
                                    alt='کارشناسان آزمایشگاه خوزکیمیا زاگرس در حال آنالیز نمونه‌های گیاهی'
                                    fill
                                    sizes='(min-width: 1024px) 28rem, 92vw'
                                    className='origin-top scale-[1.33] object-cover object-top'
                                />
                            </div>
                        </Tilt>
                    </div>
                </div>
            </div>
        </section>
    )
}
